import script from "./ThemeAndLanguageSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeAndLanguageSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./ThemeAndLanguageSwitcher.vue?vue&type=style&index=0&id=d1e9b8f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1e9b8f2"]])

export default __exports__